import { IAppointmentScheduleResponse } from "@curefit/care-common";
import { AppConstants, ConsultationStatusConstant, SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS } from "./AppConstants";
import { EpochConstants } from "./AppUtils";
import { RouteUtils } from "../routes";
import RollbarUtils from "./RollbarUtils";

export default class ConsultationUtils {
    public static getStatusButtonText(consultation: IAppointmentScheduleResponse): string {
        let currTime = new Date().getTime();
        let buttonText = "Completed";
        if (consultation.status !== ConsultationStatusConstant.COMPLETED) {
            if (new Date(consultation.endTime).getTime() > currTime) {
                buttonText = "Scheduled";
            } else {
                buttonText = ""
            }
        }
        return buttonText;
    }

    public static getStatusButtonCssClasses(consultation: IAppointmentScheduleResponse): string {
        let currTime = new Date().getTime();
        let consultationTypeCls = "completed-consultation";
        if (consultation.status !== ConsultationStatusConstant.COMPLETED) {
            if (new Date(consultation.endTime).getTime() < currTime) {
                consultationTypeCls = "uncompleted-consultation";
            } else {
                consultationTypeCls = "upcoming-consultation";
            }
        }
        return consultationTypeCls;
    }

    public static isConsultationNotCompleted(consultation: IAppointmentScheduleResponse) {
        return consultation
            ? consultation.status !== ConsultationStatusConstant.COMPLETED &&
            consultation.status !== ConsultationStatusConstant.PRESCRIPTION_GENERATED &&
            consultation.status !== ConsultationStatusConstant.CANCELLED &&
            (consultation.status === ConsultationStatusConstant.CONSULTATION_STARTED ||
                consultation.status === ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT ||
                consultation.status === ConsultationStatusConstant.MISSED ||
                consultation.status === ConsultationStatusConstant.ARRIVED_INCENTRE)
            : false
    }

    public static getStartConsultationUrl(consultation: IAppointmentScheduleResponse, isStartConsultationActionAllowed: boolean): string {
        return isStartConsultationActionAllowed ? RouteUtils.getOngoingConsultationUrl(consultation.patient.id, consultation.id) : null
    }

    public static isPackInfoRequired = (doctorType: string): boolean => {
        if (doctorType in SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS) {
            return true;
        }
        return false;
    }

    public static getPackDetails(appointment: IAppointmentScheduleResponse) {
        if (appointment.packInfo.length > 1) {
            RollbarUtils.sendErrorToRollbar(new Error("Got more than one booking membership pack details for LC."), {
                doctorId: appointment.doctor.id,
                appointmentId: appointment.id
            })
            return null;
        }
        else {
            return appointment.packInfo[0];
        }
    }
}